import { DefaultTheme } from 'styled-components';
import { defaultTheme } from './defaultTheme';
import { ConfigurableThemeProps } from './theme.types';
import { darks, lights } from './tints';

export const getPropertyTheme: (configuredTheme: ConfigurableThemeProps) => DefaultTheme = (
  configuredTheme
) => {
  const {
    primaryBrandColour,
    backgroundColour,
    secondaryBrandColour,
    tertiaryBrandColour,
    navigationFooterColour,
    headerColour,
    sectionTitleColour,
    headerFont,
    bodyFont,
  } = configuredTheme;

  return {
    ...defaultTheme,
    // Just for the backwards compatibility. Remove when freed!
    primaryBrandColour,
    secondaryBrandColour,
    tertiaryBrandColour,
    // Use colours from nested objects
    customColors: {
      ...defaultTheme.customColors,
      primary: primaryBrandColour,
      background: backgroundColour || defaultTheme.customColors.background,
      secondary: secondaryBrandColour,
      tertiary: tertiaryBrandColour,
      navigationAndFooter: navigationFooterColour,
      header: headerColour,
      sectionTitle: sectionTitleColour,
      primaryLight: lights(primaryBrandColour),
      primaryDark: darks(primaryBrandColour),
      secondaryLight: lights(secondaryBrandColour),
      secondaryDark: darks(secondaryBrandColour),
      tertiaryLight: lights(tertiaryBrandColour),
      tertiaryDark: darks(tertiaryBrandColour),
    },
    bodyFont,
    headerFont,
    primaryColour: primaryBrandColour,
    secondaryColour: secondaryBrandColour,
    tertiaryColour: tertiaryBrandColour,
    navigationFooterColour,
    headerColour,
    sectionTitleColour,
    styledBootstrapGrid: {},
  };
};
